const initialState={
    showLoginModal: false,
    showRegisterModal: false,
}

export default initialState;